import Button from "@/common/components/Button";
import { useAdvanceMaintenanceDirectiveExecutionEntry } from "@/features/maintenance/features/workflows/features/executionEntries/hooks/useAdvanceMaintenanceDirectiveExecutionEntry";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useQueryClient } from "@tanstack/react-query";

const DirectiveEntryExecutionEntryAwaitingManualStart = () => {
  const { forwarding } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry
  >();

  const queryClient = useQueryClient();

  const {
    mutate: advanceExecutionEntry,
    isPending: advanceExecutionEntryIsPending,
  } = useAdvanceMaintenanceDirectiveExecutionEntry({
    directiveEntryId: forwarding.directive_entry.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwarding.id] });
      },
    },
  });

  return (
    <Button
      onClick={() => advanceExecutionEntry()}
      isLoading={advanceExecutionEntryIsPending}
      operationKlassToCheckPermission="Establishment::Maintenance::Directive::ExecutionEntries::Advance"
    >
      Iniciar Execução da Manutenção
    </Button>
  );
}

export default DirectiveEntryExecutionEntryAwaitingManualStart;
